import React, { useEffect, useState, useRef } from 'react';
import './Timer.css';

export default function Timer({ expiresAt, onExpire }) {
  const [remaining, setRemaining] = useState(0);
  const onExpireRef = useRef(onExpire);

  useEffect(() => { onExpireRef.current = onExpire; }, [onExpire]);

  useEffect(() => {
    const computeRemaining = () => {
      const diff = Math.max(0, Math.floor((new Date(expiresAt) - Date.now()) / 1000));
      setRemaining(diff);
      return diff;
    };

    computeRemaining();
    const interval = setInterval(() => {
      const left = computeRemaining();
      if (left === 0) {
        clearInterval(interval);
        onExpireRef.current?.();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [expiresAt]);

  const mins = Math.floor(remaining / 60);
  const secs = remaining % 60;
  const isWarning  = remaining <= 300 && remaining > 60;
  const isDanger   = remaining <= 60;
  const progress   = expiresAt
    ? Math.max(0, remaining / ((new Date(expiresAt) - Date.now() + remaining * 1000) / 1000))
    : 1;

  const circumference = 2 * Math.PI * 22;
  const dashOffset = circumference * (1 - remaining / Math.max(1, remaining +
    (expiresAt ? Math.max(0, (new Date(expiresAt) - Date.now()) / 1000 - remaining) : 0)));

  return (
    <div className={`timer-wrapper ${isWarning ? 'warning' : ''} ${isDanger ? 'danger' : ''}`}>
      <svg className="timer-ring" viewBox="0 0 52 52">
        <circle className="timer-ring-bg"   cx="26" cy="26" r="22" />
        <circle className="timer-ring-fill" cx="26" cy="26" r="22"
          strokeDasharray={circumference}
          strokeDashoffset={isDanger ? circumference * 0.1 : isWarning ? circumference * 0.4 : 0}
        />
      </svg>
      <div className="timer-display">
        <span className="timer-icon">⏱</span>
        <span className="timer-digits">
          {String(mins).padStart(2, '0')}:{String(secs).padStart(2, '0')}
        </span>
        <span className="timer-label">
          {isDanger ? 'Hurry!' : isWarning ? 'Time running out' : 'Remaining'}
        </span>
      </div>
    </div>
  );
}
